import successImageSvg from "static/images/check-circle.svg";

interface Props {
  message: string;
}

export default function ControlSuccessDisplay(props: Props) {
  const { message } = props;
  return (
    <div className="absolute mt-0.5">
      <div className="flex">
        <img src={successImageSvg} alt="success" className="inline" />
        <div className="text-promDeepMint ml-1 inline">{message}</div>
      </div>
    </div>
  );
}
